import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISCMPromptDetail, ISCMPromptSearchFields, promptService, ISCMPromptFormFields, ISCMPromptInsert, ISCMPromptUpdate } from "./promptService";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "../../../utils/constants";
import { ISearchPage } from "../../../types/FmsTypes";
import { transPgToPagination } from "../../../utils/utils";
import { globalPrompt } from "../../../components/YhMessage";

interface ISCmPromptDrawerType {
    visible: boolean,
    mode: "addPeer"| "addSon" | "edit"
}

export const usePromptModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<ISCMPromptDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<ISCMPromptSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: ISCMPromptSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await promptService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: ISCMPromptSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    /**
     * 详情
     */
    const initPromptDrawer: ISCmPromptDrawerType = { visible: false, mode: "addPeer" }
    const [promptDrawer, setPromptDrawer] = useState<ISCmPromptDrawerType>(initPromptDrawer);
    const setIPromptDrawer = (str?: "addPeer"| "addSon" | "edit") => setPromptDrawer(str ? { visible: true, mode: str } : initPromptDrawer);

    //根据id查询
    const getSelectedRowData = () => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        return filters && filters.length > 0 ? filters[0] : null;
    };

    const insertPrompt = async (val: ISCMPromptInsert) => {
        let { retData } = await promptService.insert(val);
        if (retData) {
            loadData();
            setIPromptDrawer();
            // promptLoadDataAll();
            globalPrompt("message", { text: "错误日志新增成功", type: "success" })
        } else {
            globalPrompt("message", { text: "错误日志新增失败", type: "error" });
        }
    }

    //表单编辑 Api
    const editPrompt = async (val: ISCMPromptInsert) => {
        let { retData } = await promptService.update({ ...val, id: selectedRowKeys[0] });
        if (retData) {
            loadData();
            setIPromptDrawer();
            // promptLoadDataAll();
            globalPrompt("message", { text: "错误日志修改成功", type: "success" })
        } else {
            globalPrompt("message", { text: "错误日志修改失败", type: "error" });
        }
    }


    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        /***method***/
        promptDrawer, setIPromptDrawer,
        getSelectedRowData,
        insertPrompt,
        editPrompt,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
    }
});